import { render, staticRenderFns } from "./OfferDisclaimerModal.vue?vue&type=template&id=b18bafae&scoped=true"
import script from "./OfferDisclaimerModal.vue?vue&type=script&lang=ts"
export * from "./OfferDisclaimerModal.vue?vue&type=script&lang=ts"
import style0 from "./OfferDisclaimerModal.vue?vue&type=style&index=0&id=b18bafae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18bafae",
  null
  
)

export default component.exports